import { createSlice } from '@reduxjs/toolkit'

type Props = {
  dialogRewardsGetState: boolean
  dialogRewardsBadState: boolean
  dialogRewardsFinishState: boolean
  dialogRewardsComfirmState: boolean
  dialogRewardsResultState: boolean
  dialogRewardsQuestionnaireState: boolean
  rewardsQuestionnaireAnswerState: boolean
}

const initialState: Props = {
  dialogRewardsGetState: false,
  dialogRewardsBadState: false,
  dialogRewardsFinishState: false,
  dialogRewardsComfirmState: false,
  dialogRewardsResultState: false,
  dialogRewardsQuestionnaireState: false,
  rewardsQuestionnaireAnswerState: false,
}

const dialogRewardsReducer = createSlice({
  name: 'dialogRewards',
  initialState: initialState,
  reducers: {
    dialogRewardsGetState(state, action) {
      state.dialogRewardsGetState = action.payload
    },
    dialogRewardsBadState(state, action) {
      state.dialogRewardsBadState = action.payload
    },
    dialogRewardsFinishState(state, action) {
      state.dialogRewardsFinishState = action.payload
    },
    dialogRewardsComfirmState(state, action) {
      state.dialogRewardsComfirmState = action.payload
    },
    dialogRewardsResultState(state, action) {
      state.dialogRewardsResultState = action.payload
    },
    dialogRewardsQuestionnaireState(state, action) {
      state.dialogRewardsQuestionnaireState = action.payload
    },
    rewardsQuestionnaireAnswerState(state, action) {
      state.rewardsQuestionnaireAnswerState = action.payload
    },
  },
})

export const {
  dialogRewardsGetState,
  dialogRewardsBadState,
  dialogRewardsFinishState,
  dialogRewardsComfirmState,
  dialogRewardsResultState,
  dialogRewardsQuestionnaireState,
  rewardsQuestionnaireAnswerState,
} = dialogRewardsReducer.actions

export default dialogRewardsReducer.reducer
